import { render, staticRenderFns } from "./KidjoFeatures.vue?vue&type=template&id=e1644e1e&scoped=true"
import script from "./KidjoFeatures.vue?vue&type=script&lang=js"
export * from "./KidjoFeatures.vue?vue&type=script&lang=js"
import style0 from "./KidjoFeatures.vue?vue&type=style&index=0&id=e1644e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1644e1e",
  null
  
)

export default component.exports